/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace>): BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace(), model);
        BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace>): BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace.newInstance(<BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
